export const LuxuryButton = ({ children, variant = "brass", className = "", ...props }) => {
  const base =
    "group relative inline-flex items-center justify-center overflow-hidden px-8 py-4 text-[11px] font-medium uppercase tracking-[0.3em] transition-colors duration-500";
  const variants = {
    brass: {
      styles: "bg-accent text-accent-foreground hover:text-background",
      fill: "bg-foreground",
    },
    ghost: {
      styles: "border border-foreground/30 text-foreground hover:text-accent-foreground",
      fill: "bg-accent",
    },
    light: {
      styles: "border border-[#F9F6F0]/40 text-[#F9F6F0] hover:text-[#2A241F]",
      fill: "bg-[#F9F6F0]",
    },
  };
  const { styles, fill } = variants[variant] || variants.brass;
  return (
    <button className={`${base} ${styles} ${className}`} {...props}>
      <span
        className={`absolute inset-0 ${fill} translate-y-full transition-transform duration-500 ease-[cubic-bezier(0.76,0,0.24,1)] group-hover:translate-y-0`}
      />
      <span className="relative z-10 inline-flex items-center gap-3">{children}</span>
    </button>
  );
};
